import React from "react";
import { Button } from "antd";
import { MailOutlined, PhoneOutlined, ShopOutlined, UserOutlined } from "@ant-design/icons";
import type { Rep } from "types/rep";

export type RapCardProps = {
  rap: Rep;
  onEdit: (id: number) => void;
  onDeleteRequest: (id: number) => void;
};

const RapCard: React.FC<RapCardProps> = ({
  rap,
  onEdit,
  onDeleteRequest,
}) => {
  return (
    <div className="market-card">
      <div
        className="market-card-logo"
        style={{ backgroundColor: "#E8F5E9" }}
      >
        <UserOutlined className="market-card-logo-icon" style={{ color: "#35b558" }} />
      </div>

      <div className="market-card-body">
        <div className="market-card-info">
          <div className="market-card-name">{rap.name}</div>
          <div className="rap-card-meta">
            <span className="rap-card-meta-item">
              <MailOutlined /> {rap.email}
            </span>
            <span className="rap-card-meta-item">
              <PhoneOutlined /> {rap.phone}
            </span>
            <span className="rap-card-meta-item">
              <ShopOutlined /> {rap.market_name || "-"}
            </span>
            {rap.market_location && (
              <span className="rap-card-meta-item">
                <ShopOutlined /> {rap.market_location}
              </span>
            )}
          </div>
        </div>

        <div className="market-card-actions">
          <Button
            type="text"
            size="small"
            className="market-card-btn-edit"
            onClick={() => onEdit(rap.id)}
          >
            Edit
          </Button>
          <Button
            type="text"
            size="small"
            className="market-card-btn-delete"
            onClick={() => onDeleteRequest(rap.id)}
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RapCard;
